import type { BannerVariant, MixOrderIssueSeverity } from './types';

export const TEST_ID = 'compatibilityAdvisoryPanel';

export const SEVERITY_TO_BANNER_VARIANT: Record<MixOrderIssueSeverity, BannerVariant> = {
    BLOCKED: 'warn',
    INFO: 'info',
    WARNING: 'warn'
};
